import { z } from 'zod';
import { amountSchema, noteSchema } from './transaction';

export const uuidParam = z.object({ id: z.string().uuid() });

/** Токен приглашения: 16 байт base64url = 22 символа; допускаем запас. */
export const invitationTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{16,32}$/);
export const tokenParam = z.object({ token: invitationTokenSchema });

/** Метка канала (reel_1, ig_bio): тот же алфавит, что у start-параметра, до 32 символов. */
export const sourceTagSchema = z.string().regex(/^[A-Za-z0-9_-]{1,32}$/);

/**
 * Черновик первой операции в приглашении: та же валидация, что у операции (сумма, валюта,
 * заметка). Кто платил — относительно сторон приглашения, id приглашённого ещё неизвестен.
 */
export const invitationDraftSchema = z
  .object({
    amount: amountSchema,
    currency: z.string().length(3).toUpperCase().default('UZS'),
    payer: z.enum(['inviter', 'invitee']),
    note: noteSchema.nullable().default(null),
  })
  .strict();
export type InvitationDraftInput = z.infer<typeof invitationDraftSchema>;

/** Тело POST /invitations. Всё необязательно: тело без полей = приглашение без черновика. */
export const createInvitationSchema = z
  .object({ source_channel: sourceTagSchema.nullish(), draft: invitationDraftSchema.nullish() })
  .nullish();
